import { Component, OnInit, QueryList, ViewChildren, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateMessageComponent } from '../create-message/create-message.component';

import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import * as moment from 'moment';
import { Align } from '@progress/kendo-angular-popup';
import { AttachmentsListComponent } from '../attachments-list/attachments-list.component';
import { MailStatusLogComponent } from '../mail-status-log/mail-status-log.component';
import { ReplyMessageComponent } from '../reply-message/reply-message.component';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { IMsgReceiverStatus, IMsgListInputModel } from 'src/app/ViewModel/CommunicationModel';
import { SignatureComponent } from '../signature/signature.component';
import { MessageGroupComponent } from '../message-group/message-group.component';
import { MailEditComponent } from '../mail-edit/mail-edit.component';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MailHistoryLogComponent } from '../mail-history-log/mail-history-log.component';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.css']
})
export class MailComponent implements OnInit, OnDestroy {
  @ViewChildren('divIcon') divIconHover!: QueryList<any>;
  @ViewChild('mailGrid') mailGrid: any;
  @ViewChild(DataBindingDirective)
  dataBinding!: DataBindingDirective;
  public isSearch: boolean = false;
  enableFilter = false;
  enableFullscreen = false;
  pageSize = 15;
  LastViewingRecords = 30;
  LastViewingRecord: string = '30';
  noOfDays = [30, 60, 90, 'All'];
  public lastscrollLeft!: number;
  selectedIndex = 0;
  selectedRootIndex = 0;
  selectedTabIndex = 0;
  draft!: boolean;
  inbox!: boolean;
  landingall!: boolean;
  sent!: boolean;
  memberId: number = 0;
  projectId!: number;
  groupId: number = 0;
  public gridData: any[] = [];
  public data: any[] = [];
  public messageList: any[] = [];
  public searchList: any[] = [];
  public inboxList: any[] = [];
  public draftList: any[] = [];
  public sentList: any[] = [];
  public allList: any[] = [];
  public buttonType = 'MyMessages';
  public viewTabs: any = [];
  public viewData: any[] = [];
  public shareMsgList: any[] = [];
  public mailBoxType: any = null;
  IsShowCreateList = false;
  public anchorElementPopup: any;
  public margin = { horizontal: -15, vertical: 10 };
  hasSuperView: boolean = false;
  canUpload: boolean = false;
  canReply: boolean = false;
  canDelete: boolean = false;
  UnsubscribeArray: Subscription[] = [];
  public anchorAlignCenter: Align = { horizontal: 'center', vertical: 'bottom' };
  private anchorAlignRight: Align = { horizontal: 'right', vertical: 'bottom' };
  private popupAlignRight: Align = { horizontal: 'right', vertical: 'top' };

  constructor(
    private dialog: MatDialog,
    public communicationService: CommunicationService,
    public commonService: CommonService,
    private notificationService: NotificationService,
    private encryptDecryptService: EncryptDecryptService) {
    this.allData = this.allData.bind(this);
  }

  ngOnInit() {
    if (this.commonService.hasRequestedObject()) {
      setTimeout(() => {
        this.initialPageLoad();
      }, 2000);
    }
    else {
      this.initialPageLoad();
    }
  }

  initialPageLoad() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.mailBoxType = 1;
    this.callMemberRoleandFeature();
    this.refreshGrid();
  }

  callMemberRoleandFeature() {
    let memberrolefeature = this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.hasSuperView = result1.some(data => data.feature_Desc == 'Msg Super View');
      this.canUpload = result1.some(data => data.feature_Desc == 'Upload');
      this.canReply = result1.some(data => data.feature_Desc == 'Reply');
      this.canDelete = result1.some(data => data.feature_Desc == 'Delete');
    });
    this.UnsubscribeArray.push(memberrolefeature);
  }

  public advanceSearch() {
    this.searchList = [];
    switch (this.selectedRootIndex) {
      case 0:
        this.messageList = this.inboxList;
        break;
      case 1:
        this.messageList = this.draftList;
        break;
      case 2:
        this.messageList = this.sentList;
        break;
      default:
        this.messageList = this.allList;
        break;
    }
    this.isSearch = !this.isSearch;
  }

  createMessageClick() {
    const dialogRef = this.dialog.open(CreateMessageComponent, {
      panelClass: 'mat-dialog-primary',
      data: { inputType: 'createMail', selectedList: [] }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }

  registerMessageClick() {
    const dialogRef = this.dialog.open(CreateMessageComponent, {
      panelClass: 'mat-dialog-primary',
      data: { inputType: 'registerMail', selectedList: [] }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }



  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  messageListTabSplit(ListData: any[]) {
    this.inboxList = ListData.filter(doc => doc.messageBox == 1);
    this.draftList = ListData.filter(doc => doc.messageBox == 2);
    this.sentList = ListData.filter(doc => doc.messageBox == 3);
    this.allList = ListData;
    switch (this.mailBoxType) {
      case 1:
        this.messageList = this.inboxList;
        break;
      case 2:
        this.messageList = this.draftList;
        break;
      case 3:
        this.messageList = this.sentList;
        break;
      default:
        this.messageList = this.allList;
        break;
    }
    this.dataBinding.skip = 0;
  }

  closeAdvSearch(event: any[]) {
    this.searchList = event;
    this.isSearch = false;
    if (this.searchList.length == 0) {
      this.notificationService.showToast("Search returned no results", "Warning");
    }
    else {
      // this.messageList = this.searchList;
      // this.dataBinding.skip = 0;
      this.messageListTabSplit(this.searchList);
    }
  }

  getGridData() {
    if (this.selectedTabIndex != 0) {
      this.viewData = [];
      let tab = this.viewTabs[this.selectedTabIndex - 1];
      this.viewData.push({
        projectId: this.projectId,
        groupId: this.groupId,
        messageId: tab.messageId
      });
    }
    // if (this.searchList.length > 0) {
    //   this.messageList = this.searchList;
    // }
    // else {
    //   this.inboxList = this.gridData.filter(doc => doc.messageBox == 1);
    //   this.draftList = this.gridData.filter(doc => doc.messageBox == 2);
    //   this.sentList = this.gridData.filter(doc => doc.messageBox == 3);
    //   this.allList = this.gridData;
    //   switch (this.mailBoxType) {
    //     case 1:
    //       this.messageList = this.inboxList;
    //       break;
    //     case 2:
    //       this.messageList = this.draftList;
    //       break;
    //     case 3:
    //       this.messageList = this.sentList;
    //       break;
    //     default:
    //       this.messageList = this.allList;
    //       break;
    //   }
    //   this.dataBinding.skip = 0;
    // }
    this.messageListTabSplit(this.gridData);
  }

  onHover(event: Event): void {
    if ((event.target as HTMLElement).closest('div.k-grid-content')) {
      const newscrollLeft = (event.target as HTMLElement).closest('div.k-grid-content')?.scrollLeft;
      if (newscrollLeft && this.lastscrollLeft !== newscrollLeft) {
        for (let i = 0; i < this.divIconHover.length; i++) {
          this.divIconHover['_results'][i]['nativeElement']['style'].right = (0 - newscrollLeft) + 'px';
        }
        this.lastscrollLeft = newscrollLeft;
      }
    }
  }

  public onValChange(val: string) {
    this.searchList = [];
    this.buttonType = val;
    this.refreshGrid();
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  public tabClick(event: { tab: { textLabel: string; }; }) {
    this.mailGrid.defaultSelection.selectedKeys = [];
    this.messageList.forEach(x => x.isSelected = false);
    //this.searchList = [];
    if (event.tab.textLabel == "Inbox") {
      this.mailBoxType = 1;
    }
    else if (event.tab.textLabel == "Draft") {
      this.mailBoxType = 2;
    }
    else if (event.tab.textLabel == "Sent") {
      this.mailBoxType = 3;
    }
    else {
      this.mailBoxType = null;
    }
    this.refreshGrid(true);
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  /**
  * Data Binding in Grid
  * @param type
  *
  */
  public async refreshGrid(isTabChange: boolean = false) {
    let inputMsgId = null;
    let inputMsgNo = null;
    if (this.commonService.hasRequestedObject()) {
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      inputMsgId = requestedObject['inputDocId'];
    }
    if (this.commonService.hasSearchedObject()) {
      var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('searchedObject')));
      inputMsgNo = searchedObject['searchDocNo'];
    }
    var toDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    let lastViewingDate = moment().add(-this.LastViewingRecords, 'days');
    var fromDate = new Date(lastViewingDate.toDate());
    let reqData: IMsgListInputModel = {
      transType: this.buttonType,
      projectId: this.projectId,
      groupId: this.groupId,
      memberId: this.memberId,
      mailBoxType: null,
      isConfidential: null,
      sentType: this.LastViewingRecords == 0 ? null : 'Sent',
      sentFrom: this.LastViewingRecords == 0 ? null : fromDate,
      sentTo: this.LastViewingRecords == 0 ? null : toDate,
      messageId: inputMsgId == null ? inputMsgId : +inputMsgId,
      messageNo: inputMsgNo
    };
    if (!isTabChange) {
      this.gridData = await this.communicationService.GetMessageList(reqData).toPromise().catch(err => {
        console.log(err);
        this.notificationService.showToast("the Search List is too large to fetch Please use Advance Search",'Warning');
        this.messageList=[];
      });
    }
    if(this.searchList.length>0)
    {
      this.gridData=this.searchList
    }
    this.getGridData();
    this.setRedirectObjects();
  }

  setRedirectObjects() {
    if (this.commonService.hasRequestedObject()) {/*Mail Redirection*/
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      let inputMsgId = requestedObject['inputMsgId'];
      if (inputMsgId) {
        this.commonService.checkAndDeleteRequestedObject();
        let _data = this.gridData?.filter(x => x.messageId == inputMsgId);
        if (_data.length > 0) {
          this.viewMessageClick(_data[0]);
        }
        else {
          let reqData: IMsgListInputModel = {
            transType: this.buttonType,
            projectId: this.projectId,
            groupId: this.groupId,
            memberId: this.memberId,
            messageId: inputMsgId
          }
          this.communicationService.GetMessageList(reqData).subscribe((res:any[]) => {
            if(res && res.length>0)
            {
              this.viewMessageClick(res[0]);
            }
            else
            {
              this.notificationService.showToast("You are not authorized to view the Message", "Warning");
            }
          },err => {
            this.notificationService.showToast("You are not authorized to view the Message", "Warning");
          })

        }
      }
    }
    if (this.gridData.length > 0 && this.commonService.hasSearchedObject()) {/*Search Redirection*/
      var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('searchedObject')));
      let inputMsgNo = searchedObject['searchDocNo'];
      if (inputMsgNo) {
        this.commonService.checkAndDeleteSearchedObject();
        let _data = this.gridData.filter(x => x.messageNumber == inputMsgNo);
        if (_data.length > 0) {
          this.viewMessageClick(_data[0]);
        }
        else {
          this.notificationService.showToast("You are not authorized to view the Message", "Warning");
        }
      }
    }
  }

  /**
   * Multiple select of listed messages
   * @param event
   *
   */
  onSelectionChange(event: { [x: string]: { dataItem: { isSelected: boolean; }; }[]; }): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = false;
      });
    }
  }

  respondMessage(respondType: number, dataItem?: any) {
    let inputType = respondType == 1 ? 'replyMail' : (respondType == 2 ? 'replyAllMail' : 'ForwardMail');
    let selectedMessages = [];
    if (dataItem != undefined && dataItem != null) {
      selectedMessages.push(dataItem.messageId);
    }
    else {
      selectedMessages = this.messageList.filter(x => x.isSelected).map(x => x.messageId);
    }
    if (selectedMessages.length == 1) {
      const dialogRef = this.dialog.open(ReplyMessageComponent, {
        panelClass: 'mat-dialog-primary',
        disableClose: true,
        data: { inputType: inputType, selectedMessageId: selectedMessages[0] }
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        this.refreshGrid();
        this.mailGrid.defaultSelection.selectedKeys = [];
        this.messageList.forEach(x => x.isSelected = false);
      });
    }
    else {
      this.notificationService.showToast("Please Select One Mail", "Warning");
    }
  }

  public showCreateList(event: any) {
    this.IsShowCreateList = !this.IsShowCreateList;
    this.anchorElementPopup = event.target;
  }

  public closeCreateList() {
    this.IsShowCreateList = false;
    this.anchorElementPopup = undefined;
  }

  viewAttachmentClick(data: any) {
    this.dialog.open(AttachmentsListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: { messageId: data.messageId },
    });
  }

  public lastviewingrecordsmethod(event: any) {
    this.searchList = [];
    if (event == "All") {
      this.LastViewingRecords = 0;
      this.refreshGrid();
      this.LastViewingRecord = "All";
    }
    else {
      this.LastViewingRecords = event;
      this.LastViewingRecord = event;
      this.refreshGrid();
    }
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  public viewTabClick(event: { tab: { textLabel: any; }; }) {
    this.viewData = [];
    this.messageList.forEach(x => x.isSelected = false);
    if (this.selectedTabIndex != 0) {
      let msgId = this.viewTabs.find((x: { messageNumber: any; }) => x.messageNumber == event.tab.textLabel).messageId;
      this.viewData.push({
        projectId: this.projectId,
        groupId: this.groupId,
        messageId: msgId,
      });
    }
  }

  async closeTabClick(tab: { messageId: any; }) {
    let index = this.viewTabs.indexOf(tab);
    this.viewTabs.splice(index, 1);
    let input: IMsgReceiverStatus = {
      messageId: tab.messageId,
      memberId: this.memberId,
      isRead: 'Y',
      readOn: new Date(),
      responseDate: null,
      userId: this.memberId
    };
    let setmessage = await this.communicationService.setMessageStatus(input).subscribe((res: any) => { });
    this.UnsubscribeArray.push(setmessage);
    if (this.viewTabs.length == 0) {
      this.selectedTabIndex = 0;
      this.refreshGrid();
    }
  }

  viewMessageClick(data: any) {
    let index = this.viewTabs.indexOf(data);
    if (index == -1) {
      this.viewTabs.push(data);
      this.selectedTabIndex = 1;
    }
  }

  viewMessagesClick() {
    this.messageList.forEach((element: any) => {
      if (element.isSelected) {
        let index = this.viewTabs.indexOf(element);
        if (index == -1) {
          this.viewTabs.push(element);
        }
      }
    });
    if (this.viewTabs.length == 0) {
      this.notificationService.showToast("No Mail is selected", "Warning");
    }
    else {
      this.selectedTabIndex = 1;
    }
  }

  viewStatusLog(data: any) {
    this.dialog.open(MailStatusLogComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: { messageId: data.messageId, messageNo: data.messageNumber, messageSubject: data.messageSubject },
    });
  }

  viewHistoryLog(data: any) {
    this.dialog.open(MailHistoryLogComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: { messageId: data.messageId },
    });
  }

  openSignaturePopup() {
    const dialogRef = this.dialog.open(SignatureComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '60%',
      maxWidth: '60vw'
    });
  }

  openMessageGroupPopup() {
    const dialogRef = this.dialog.open(MessageGroupComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '95%',
      maxWidth: '95vw',
      data: { receiverType: 0, alreadySelectedList: [] }
    });
  }

  editMessage(data: any) {
    const dialogRef = this.dialog.open(MailEditComponent, {
      panelClass: 'mat-dialog-primary',
      data: { messageId: data.messageId }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }

  deleteMessage(data: any) {
    this.notificationService.showPopup('Are you sure you want to delete', 'Confirm').then(msg => {
      if (msg == 'yes') {
        let input = {
          "projectId": this.projectId,
          "messageId": data.messageId,
          "userId": this.memberId
        };
        let deletemsg = this.communicationService.DeleteMessage(input).subscribe(res => {
          if (res.successCode == 200) {
            this.refreshGrid();
            this.notificationService.showToast(res.successMessage, "Success");
          }
          else if (res.successCode == 500) {
            this.notificationService.showToast(res.successMessage, "Error");
          }
        });
        this.UnsubscribeArray.push(deletemsg);
      }
    });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.messageList
    };
    return result;
  }

  public HelpUrlClick() {
    let x = JSON.parse(this.commonService.getSessionStorageItem("Menu"))
    let url = x.filter((y: { menuDesc: string; }) => y.menuDesc == "Communication")[0].helpUrl
    if (url) {
      window.open(url);
    }
  }

  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}
